import { request } from '@umijs/max';

export async function getIdInformationQueryRequest() {
  const response = await request<API.IResult<API.GetIdInformationQueryDto>>(`/api/profile`, {
    method: 'GET',
  });

  return response.data;
}

export async function createIdInformationCommandRequest(
  params: PARAMS.CreateIdInformationCommandRequestParams,
) {

  const formData = new FormData();
  formData.append('name', params.name!);
  formData.append('surname', params.surname!);
  formData.append('idNo', params.idNo!);
  formData.append('nationalityId', params.nationalityId!.toString());

  if (params.profilePhoto) {
    formData.append('profilePhoto', params.profilePhoto!);
  }

  const response = await request<API.IResult<API.GetIdInformationQueryDto>>(`/api/profile`, {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
}

export async function updateIdInformationCommandRequest(
  params: PARAMS.UpdateIdInformationCommandRequestParams,
) {

  const formData = new FormData();
  formData.append('name', params.name!);
  formData.append('surname', params.surname!);
  formData.append('idNo', params.idNo!);
  formData.append('nationalityId', params.nationalityId!.toString());

  if (params.profilePhoto) {
    formData.append('profilePhoto', params.profilePhoto!);
  }

  const response = await request<API.IResult<API.GetIdInformationQueryDto>>(`/api/profile`, {
    method: 'PUT',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
}

export async function getExamsCommandRequest(
  params: PARAMS.GetListUserCentralExamByUserIdQueryParams,
) {
  const response = await request<
    API.IResult<API.PaginateResult<API.GetListUserCentralExamByUserIdQueryItemDto>>
  >(`/api/profile/exams`, {
    method: 'GET',
    params: params,
  });

  return response.data;
}

export async function createExamsCommandRequest(
  params: PARAMS.CreateUserCentralExamCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetListUserCentralExamByUserIdQueryItemDto>>(
    `/api/profile/exams`,
    {
      method: 'POST',
      data: params,
    },
  );

  return response;
}

export async function updateExamsCommandRequest(
  params: PARAMS.UpdateUserCentralExamCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetListUserCentralExamByUserIdQueryItemDto>>(
    `/api/profile/exams/${params.id}`,
    {
      method: 'PUT',
      data: params,
    },
  );

  return response;
}

export async function deleteExamsCommandRequest(
  params: PARAMS.DeleteUserCentralExamCommandRequestParams,
) {
  const response = await request<API.IResult>(`/api/profile/exams/${params.id}`, {
    method: 'DELETE',
  });

  return response;
}

export async function getLearningProcessCommandRequest(
  params: PARAMS.GetListLearningProcessByUserIdQueryParams,
) {
  const response = await request<
    API.IResult<API.PaginateResult<API.GetListLearningProcessByUserIdQueryItemDto>>
  >(`/api/profile/learning-processes`, {
    method: 'GET',
    params: params,
  });

  return response.data;
}

export async function createLearningProcessCommandRequest(
  params: PARAMS.CreateLearningProcessCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetListLearningProcessByUserIdQueryItemDto>>(
    `/api/profile/learning-processes`,
    {
      method: 'POST',
      data: params,
    },
  );

  return response;
}

export async function updateLearningProcessCommandRequest(
  params: PARAMS.UpdateLearningProcessCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetListLearningProcessByUserIdQueryItemDto>>(
    `/api/profile/learning-processes/${params.id}`,
    {
      method: 'PUT',
      data: params,
    },
  );

  return response;
}

export async function deleteLearningProcessCommandRequest(
  params: PARAMS.DeleteLearningProcessCommandRequestParams,
) {
  const response = await request<API.IResult>(`/api/profile/learning-processes/${params.id}`, {
    method: 'DELETE',
  });

  return response;
}

export async function uploadFileRequest(param: PARAMS.UploadDocumentCommandRequestParams) {
  const formData = new FormData();
  //formData.append('applicationId', param.applicationId!.toString());
  formData.append('documentTypeId', param.documentTypeId!.toString());
  formData.append('document', param.document!);

  const response = await request<API.IResult>('/api/profile/documents', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
}

export async function deleteFileRequest(param: PARAMS.RemoveDocumentCommandRequestParams) {
  const response = await request<API.IResult>(`/api/profile/documents/${param.documentId}`, {
    method: 'DELETE',
  });

  return response;
}

export async function downloadFileRequest(param: PARAMS.DownloadDocumentQueryParams) {
  const response = await request<Blob>(`/api/profile/documents/${param.documentId}`, {
    method: 'GET',
    responseType: 'blob',
    responseInterceptors: [
      (response) => {
        // Content-Disposition başlığından dosya adını çıkar
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'downloaded-file';

        if (contentDisposition) {
          // Öncelikle filename* değerini kontrol et
          const fileNameUtf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (fileNameUtf8Match && fileNameUtf8Match[1]) {
            fileName = decodeURIComponent(fileNameUtf8Match[1]);
          } else {
            // Eğer filename* yoksa, filename değerini kontrol et
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1];
            }
          }
        }

        // Blob'u indir
        const url = window.URL.createObjectURL(new Blob([response.data as Blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Dosya adını ayarla
        document.body.appendChild(link);
        link.click();
        link.remove();

        return response;
      },
    ],
  });

  return response;
}

export async function getContactByUserIdQueryRequest() {
  const response = await request<API.IResult<API.GetContactByUserIdQueryDto>>(
    `/api/profile/contact`,
    {
      method: 'GET',
    },
  );

  return response.data;
}

export async function createContactCommandRequest(
  params: PARAMS.CreateContactCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetContactByUserIdQueryDto>>(
    `/api/profile/contact`,
    {
      method: 'POST',
      data: params,
    },
  );

  return response;
}

export async function updateContactCommandRequest(
  params: PARAMS.UpdateContactCommandRequestParams,
) {
  const { id, ...rest } = params;
  const response = await request<API.IResult<API.GetContactByUserIdQueryDto>>(
    `/api/profile/contact/${id}`,
    {
      method: 'PUT',
      data: rest,
    },
  );

  return response;
}

export async function createYosLearningProcessCommandRequest(
  params: PARAMS.CreateYosLearningProcessCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetListLearningProcessByUserIdQueryItemDto>>(
    `/api/profile/learning-processes/yos`,
    {
      method: 'POST',
      data: params,
    },
  );

  return response;
}

export async function updateYosLearningProcessCommandRequest(
  params: PARAMS.UpdateYosLearningProcessCommandRequestParams,
) {
  const { id, ...rest } = params;
  const response = await request<API.IResult<API.GetListLearningProcessByUserIdQueryItemDto>>(
    `/api/profile/learning-processes/yos/${id}`,
    {
      method: 'PUT',
      data: rest,
    },
  );

  return response;
}

export async function getYosLearningProcessCommandRequest() {
  const response = await request<API.IResult<API.GetYosLearningProccessByUserIdQueryDto>>(
    `/api/profile/learning-processes/yos`,
    {
      method: 'GET',
    },
  );

  return response.data;
}

export async function getYosIdInformationQueryRequest() {
  const response = await request<API.IResult<API.GetYosIdInformationQueryDto>>(`/api/profile/yos`, {
    method: 'GET',
  });

  return response.data;
}

export async function createIdInformationYosCommandRequest(
  params: PARAMS.CreateIdInformationYosCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetYosIdInformationQueryDto>>(
    `/api/profile/yos`,
    {
      method: 'POST',
      data: params,
    },
  );

  return response;
}

export async function updateIdInformationYosCommandRequest(
  params: PARAMS.UpdateIdInformationYosCommandRequestParams,
) {
  const response = await request<API.IResult<API.GetYosIdInformationQueryDto>>(
    `/api/profile/yos/`,
    {
      method: 'PUT',
      data: params,
    },
  );

  return response;
}